import { useState, useEffect } from 'react';

const LINE_URL = 'https://line.me/R/ti/p/@ula6319m?oat_content=url';

const navItems = [
  { label: '制作事例', href: '#achievements' },
  { label: '料金', href: '#pricing' },
  { label: 'オーダー方法', href: '#order-steps' },
  { label: 'FAQ', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-purple-900/20 border-b border-yellow-500/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/ada59f66167ebf45d369ae58cba4efc2.png"
            alt="オリシャンロゴ"
            className="h-10 md:h-12 w-auto brightness-0 invert"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6 ml-auto mr-6">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="text-sm font-medium text-gray-300 hover:text-yellow-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Desktop CTA */}
        <a
          href={LINE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:inline-flex items-center gap-2 bg-[#06C755] hover:bg-[#05b34c] text-white text-sm font-bold px-5 py-2.5 rounded-full shadow-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-line-fill text-lg"></i>
          無料相談はこちら
        </a>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニューを開く"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        } bg-black/98 border-t border-yellow-500/20`}
      >
        <nav className="flex flex-col px-6 py-4 gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="text-base font-medium text-gray-300 hover:text-yellow-400 py-3 border-b border-purple-900/30 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
          <a
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center justify-center gap-2 bg-[#06C755] hover:bg-[#05b34c] text-white text-base font-bold px-6 py-3 rounded-full shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-xl"></i>
            無料相談はこちら
          </a>
        </nav>
      </div>
    </header>
  );
}
